/** @format */

import React from "react";

type signUpButtonProps = {
  className: string;
};

const SignUpButton = ({ className }: signUpButtonProps) => {
  return (
    <a href="#footer">
      <button
        className={`${className} uppercase rounded-[4px] bg-[#8934A7] px-[17px] py-2 text-white cursor-pointer`}
      >
        Sign up Now
      </button>
    </a>
  );
};

export default SignUpButton;
